/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 *
 *
 * @export
 * @interface SetPublishedVersionResponse
 */
export interface SetPublishedVersionResponse {
  /**
   * Status message
   *
   * @type {string}
   * @memberof SetPublishedVersionResponse
   * @example Firmware version 1.2.3 set as published for CM7
   */
  message: string;

  /**
   * Software type that was updated
   *
   * @type {number}
   * @memberof SetPublishedVersionResponse
   */
  software_type: SetPublishedVersionResponseSoftwareTypeEnum;

  /**
   * Version that is now published
   *
   * @type {string}
   * @memberof SetPublishedVersionResponse
   * @example 1.2.3
   */
  version: string;

  /**
   * Previously published version (null if none existed)
   *
   * @type {string}
   * @memberof SetPublishedVersionResponse
   * @example 1.0.0
   */
  previous_version: string | null;
}

/**
 * @export
 * @enum {string}
 */
export enum SetPublishedVersionResponseSoftwareTypeEnum {
  NUMBER_0 = 0,
  NUMBER_1 = 1,
  NUMBER_2 = 2,
}
